import React from 'react';
import {Box, Grid, Card, CardContent, Typography} from '@deere/fuel-react';
import {Link} from "react-router-dom";

export const NoData = ({noDataMessage}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Card>
                    <CardContent>
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <Typography variant="h4" gutterBottom>
                                {noDataMessage.textLine1}
                            </Typography>
                            {noDataMessage.textLine2 && (
                                <Typography color="secondary" gutterBottom>
                                    {noDataMessage.textLine2}{" "}
                                    <Link
                                        to={{
                                            pathname: noDataMessage.path,
                                        }}>{noDataMessage.textLine3}</Link>
                                </Typography>
                            )}
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
}
